import { Route, Routes } from "react-router-dom";
import "./App.css";
import PageNotFound from "./component/404/404Error";
import ViewDocument from "./component/home/ViewDocument";
import ViewDocumentShortCode from "./component/home/ViewDocumentShortCode";
import ViewDocumentAuth from "./component/home/ViewDocumentAuth";
import TestingComponent from "./component/home/TestingComponent";

const Base = () => {
  return (
    <>
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/view-document" element={<ViewDocument />} />
        <Route path="/view-document-auth/:prefix/:uuid?" element={<ViewDocumentAuth />} />
        <Route path="/:prefix?/:shortCode?" element={<ViewDocumentShortCode />} />
      </Routes>
    </>
  );
};

export default Base;